module.exports = __webpack_public_path__ + "img/pic_russia_07.04531f46.jpg";